const Promise = require('bluebird')
const { send: ajax } = require('client/lib/request')
const { getPageContext, track } = require('client/lib/analytics')
const ArticleShareModal = require('client/components/article-share-modal')
const { alert, confirm } = require('client/components/confirm')

const REPORT_BUTTONS = [
  { label: 'It displays a sensitive image', value: 'image' },
  { label: `It's abusive or harmful`, value: 'nsfl' },
  { label: 'The link is broken', value: 'dead' },
  { label: 'This is my intellectual property', value: 'copyright' },
  { label: 'Cancel', value: '' }
]

function actionsButtons({ article }) {
  const { hostname } = article
  const currentPageContext = getPageContext()
  let shareAction = null
  // The article profile context already has a separate share button
  if (currentPageContext['page_name'] !== 'article.card') {
    shareAction = { label: 'Share this post', value: 'share' }
  }
  return [
    shareAction,
    { label: `I'm not interested in this`, value: 'boring' },
    { label: `This is spam`, value: 'spam' },
    { label: `Stop recommending ${hostname}`, value: 'block' },
    { label: 'Additional report options', value: 'report' },
    { label: 'Cancel', value: '' }
  ]
  .filter(x => !!x) // Remove null shareAction
}

function reportArticle({ article, reason, pageContext }) {
  const { 'url_id': urlId } = article
  const { id: userId } = window.wiggin.user
  if (reason === 'copyright') {
    if (window.Intercom.trackEvent) {
      // trackEvent may not always be enabled since
      // we don't always capture user data for Intercom
      // see views/partials/scripts/intercom.pug
      window.Intercom.trackEvent('report copyright', {
        'article url': article.url,
        'mix url': window.location.href,
        'url_id': urlId
      })
    }
    window.Intercom('showNewMessage', '')
    return Promise.resolve()
  }
  return ajax({
    url: '/api/v0.1/reports/url',
    method: 'post',
    data: {
      'url_id': urlId,
      context: reason,
      'page_context': pageContext
    }
  })
  .then(() =>
    track('report-url', {
      'url_id': urlId,
      'reporter_id': userId,
      context: reason,
      metabase: {
        'actioned_object_type': 'report',
        'actioned_object_id': urlId
      },
      'page_context': pageContext
    })
  )
  .then(() => alert({
    heading: 'Post Reported',
    subheading: 'Got it - thanks for letting us know!'
  }))
  .then(() => reason)
}

function blockDomain({ article, pageContext }) {
  const { 'url_id': urlId, hostname } = article
  const { id: userId } = window.wiggin.user
  return ajax({
    url: '/api/v0.1/reports/domain',
    method: 'post',
    data: {
      'url_id': urlId,
      'page_context': pageContext
    }
  })
  .then(() =>
    track('report-domain', {
      'url_id': urlId,
      'reporter_id': userId,
      metabase: {
        'actioned_object_type': 'report',
        'actioned_object_id': urlId
      },
      'page_context': pageContext
    })
  )
  .then(() => alert({
    heading: 'Domain Muted',
    subheading: `
      "${hostname}" will no longer be recommended to you,
      but you may still see content from this domain in
      search results and pages curated by users.
    `
  }))
  .then(() => 'block')
}

function confirmArticleAction(options) {
  return confirm({
    heading: 'Actions for this Post',
    buttons: actionsButtons(options),
    closeOnBackdropClick: true
  })
  .then(action => {
    switch (action) {
      case 'boring':
      case 'spam':
        return reportArticle(Object.assign({}, options, { reason: action }))
      case 'report':
        return confirmReportReason(options)
      case 'block':
        return blockDomain(options)
      case 'share':
        return ArticleShareModal.promise(options)
    }
  })
}

function confirmReportReason(options) {
  return confirm({
    heading: 'Report Post',
    subheading: 'What is your reason for reporting this post?',
    buttons: REPORT_BUTTONS,
    closeOnBackdropClick: true
  })
  .then(reason => {
    if (reason) {
      return reportArticle(Object.assign({}, options, { reason }))
    }
  })
}

module.exports = {
  // Confirm modals
  confirmArticleAction,
  confirmReportReason,
  // Actions
  blockDomain,
  reportArticle
}
